<app-upsell-card
  htmlTitle="<strong>Expedited</strong> Shipping"
  question="Would you like to upgrade to Overnight Shipping?"
  [slug]="slug"
>
  <p class="mb-4">
    Upgrade to <strong>Overnight Shipping</strong> and get your medication delivered overnight after your prescription
    is approved. Standard shipping takes 3-5 business days — choose overnight to skip the delay and begin treatment
    faster.
  </p>
</app-upsell-card>
